import React, {FC} from "react";
import dynamic from "next/dynamic";
import {useLocale} from "@utils/locale";
import {LocaleEnum} from "../../types/general";

const CS = dynamic(() => import('./cs'));
const EN = dynamic(() => import('./en'));
const SK = dynamic(() => import('./sk'));

export const IntlProvider: FC = ({children}) => {
    const locale = useLocale();

    switch (locale) {
        default:
        case LocaleEnum.cs: return (
            <CS>
                {children}
            </CS>
        );
        case LocaleEnum.sk: return (
            <SK>
                {children}
            </SK>
        );
        case LocaleEnum.en: return (
            <EN>
                {children}
            </EN>
        );
    }
}
